import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Lune / mode sombre / nuit / plages nuit — croissant duotone */
export const MoonIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Croissant rempli menthe */}
      <path
        d="M20 14a8 8 0 1 1-10-10 6 6 0 0 0 10 10z"
        fill="var(--equiply-icon-bg)" fillOpacity="0.6"
      />
      {/* Contour bleu */}
      <path
        d="M20 14a8 8 0 1 1-10-10 6 6 0 0 0 10 10z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Petites étoiles */}
      <circle cx="17" cy="6" r="0.8" fill="var(--equiply-icon-fg)" />
      <circle cx="14" cy="3.5" r="0.6" fill="var(--equiply-icon-fg)" />
    </svg>
  ),
);
MoonIcon.displayName = "MoonIcon";
